import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = { p: 0 };

export const dialogTitle: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const dialogContent: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden !important',
  gap: (p) => p.spacing(2),
};

export const icon: SxStyle = {
  cursor: 'pointer',
  color: (p) => p.palette.primary[400],
};
